import type { MatkulGradeItem } from "@/types";

function formatGrade(item: MatkulGradeItem): string {
    return item.nilai ? `${item.nilai}` : `${item.grade}/4`;
}

function template1(data: MatkulGradeItem[], dosen: string): string {
    const lines = data.map(
        (d, i) => `${i + 1}. **${d.name}** _(Smt ${d.smtOrdinal}, ${d.tahun}, Kelas ${d.kelas})_ — ⭐ **${formatGrade(d)}**`
    );
    return `Daftar matkul yang pernah diajar **${dosen}** ke kamu:\n${lines.join('\n')}`;
}

function template2(data: MatkulGradeItem[], dosen: string): string {
    if (data.length === 1) {
        const item = data[0];
        return `**${dosen}** pernah ngajar kamu di matkul **${item.name}** _(Kelas ${item.kelas}, Semester ${item.smtOrdinal}, ${item.tahun})_ dengan nilai **${formatGrade(item)}**.`;
    }

    const lines = data.map((d) => `• **${d.name}** \`[Kelas ${d.kelas} | Smt ${d.smtOrdinal}/${d.tahun}]\` ➔ **${formatGrade(d)}**`);
    return `**${dosen}** pernah mengajar kamu di **${data.length} mata kuliah**:\n\n${lines.join('\n\n')}`;
}

function template3(data: MatkulGradeItem[], dosen: string): string {
    const lines = data.map(
        (d) => `• **${d.name}** *(Kelas ${d.kelas}, Semester ${d.smtOrdinal}, ${d.tahun})*\n\n&nbsp;&nbsp;└ Nilai: **${formatGrade(d)}**`
    );
    return `📜 Riwayat Perkuliahan bersama **${dosen}:**\n\n${lines.join('\n\n')}`;
}

function template4(data: MatkulGradeItem[], dosen: string): string {
    const lines = data.map(
        (d, i) => `${i + 1}. **${d.name}** \`[Kelas ${d.kelas} | Smt ${d.smtOrdinal}/${d.tahun}]\` — ⭐ **${formatGrade(d)}**`
    );
    return `📚 Berikut matkul kamu yang diampu oleh **${dosen}**:\n${lines.join('\n')}`;
}

function template5(data: MatkulGradeItem[], dosen: string): string {
    const lines = data.map((d) => `- **${d.name}** _(Kelas ${d.kelas} - Semester ${d.smtOrdinal} - ${d.tahun})_ 🎓 Nilai: **${formatGrade(d)}**`);
    return `Bareng **${dosen}**, kamu pernah mengambil:\n${lines.join('\n')}`;
}

// Fallback jika belum pernah diajar dosen ini
function templateNotFound(dosen: string): string {
    return `❌ Kamu belum pernah dicatat mengambil mata kuliah yang diajar oleh **${dosen}**.`;
}

export function generateMyDosenMatkulResponse(
    data: MatkulGradeItem[],
    dosen: string
): string {
    if (data.length === 0) {
        return templateNotFound(dosen);
    }

    const templates = [template1, template2, template3, template4, template5];
    const chosen = templates[Math.floor(Math.random() * templates.length)];
    return chosen(data, dosen);
}